import { render } from "./SiteDetail.vue?vue&type=template&id=2b394b82&scoped=true"
import script from "./SiteDetail.vue?vue&type=script&lang=js"
export * from "./SiteDetail.vue?vue&type=script&lang=js"

import "./SiteDetail.vue?vue&type=style&index=0&id=2b394b82&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b394b82"],['__file',"src/views/h5/luqiao/project/site/SiteDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b394b82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b394b82', __exports__)) {
    api.reload('2b394b82', __exports__)
  }
  
  module.hot.accept("./SiteDetail.vue?vue&type=template&id=2b394b82&scoped=true", () => {
    api.rerender('2b394b82', render)
  })

}


export default __exports__